module.exports = __webpack_public_path__ + "img/2024-03-19c_1.147b2f52.jpg";